import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export const EntryDialog = ({ open, onOpenChange, initial, onSave }) => {
  const [f, setF] = useState({});
  useEffect(() => { if (open) setF({ ...initial }); }, [open, initial]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const valid = f.amount !== "" && f.amount != null && f.entry_date;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="entry-form-dialog" className="sm:max-w-sm" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="font-head text-2xl">Edit entry</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600">{f.site_name} · <span className="font-mono">{f.user_code}</span></p>
        <form onSubmit={(e) => { e.preventDefault(); if (valid) onSave({ ...f, amount: parseFloat(f.amount) }); }} className="space-y-4">
          <div className="space-y-1.5">
            <Label>Date</Label>
            <Input data-testid="entry-date-input" type="date" value={f.entry_date || ""} onChange={set("entry_date")} />
          </div>
          <div className="space-y-1.5">
            <Label>Settlement amount (₹)</Label>
            <Input data-testid="entry-amount-input" type="number" step="0.01" className="font-mono" value={f.amount ?? ""} onChange={set("amount")} />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={!valid} className="bg-sky-600 hover:bg-sky-700" data-testid="entry-save-btn">Save</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
